import Swiper from "swiper";


const productionSwiper = new Swiper('.production-swiper-container', {
  slidesPerView: 1,
  spaceBetween: 30,
  loop: true,

  navigation: {
    prevEl: '.swiper-button-prev',
    nextEl: '.swiper-button-next',
  },

  breakpoints: {
    768: {
      slidesPerView: 3
    }
  }
})

